<script setup lang="ts">
import { computed } from 'vue'
import { formatStopTime } from '@/utils/timeStrings'

const props = defineProps<{
  dropoffDatetime: string
  timeZone: string
}>()

const stopTime = computed(() => {
  return formatStopTime(props.dropoffDatetime, props.timeZone)
})
</script>

<template>
  <div class="timeline-stop__time timeline-stop__title">
    Estimated arrival:
    {{ stopTime }}
  </div>
</template>
<style lang="scss" scoped>
.timeline-stop__time {
  color: var(--cu-gray-300);
}
</style>
